import React, { useEffect, useState } from "react";
import { Typography, Button, Upload, message, Spin } from "antd";
import {
  DeleteOutlined,
  LoadingOutlined,
  PaperClipOutlined,
  SettingOutlined,
} from "@ant-design/icons";

import { documentationType } from "../../../helpers/constants";

const { Title, Text } = Typography;

const RoleLaDokumentacija = ({ state, actions }) => {
  const { documentation, uploadingType } = state;
  const [documentationPravnaLica, setDocumentationPravnaLica] = useState(null);
  const [documentationFizickaLica, setDocumentationFizickaLica] =
    useState(null);
  const [documentationObradaPodataka, setDocumentationObradaPodataka] =
    useState(null);

  useEffect(() => {
    actions.getDocumentation();
  }, []);

  useEffect(() => {
    documentation.length > 0 &&
      documentation.map((doc) => {
        switch (doc.documentationType) {
          case documentationType.pravnaLica:
            return setDocumentationPravnaLica(doc);
          case documentationType.fizičkaLica:
            return setDocumentationFizickaLica(doc);
          case documentationType.informacijeoObradiPodataka:
            return setDocumentationObradaPodataka(doc);
        }
      });
  }, [documentation]);

  const uploadDocumentationPravnaLica = (info) => {
    actions.uploadDocumentation(info.file, documentationType.pravnaLica);
  };

  const uploadDocumentationFizickaLica = (info) => {
    actions.uploadDocumentation(info.file, documentationType.fizičkaLica);
  };

  const uploadDocumentationObradaPodataka = (info) => {
    actions.uploadDocumentation(
      info.file,
      documentationType.informacijeoObradiPodataka
    );
  };

  const handleRemove = (doc) => {
    actions.documentationDelete(doc.id);

    switch (doc.documentationType) {
      case documentationType.pravnaLica:
        return setDocumentationPravnaLica(null);
      case documentationType.fizičkaLica:
        return setDocumentationFizickaLica(null);
      case documentationType.informacijeoObradiPodataka:
        return setDocumentationObradaPodataka(null);
    }
  };

  return (
    <div className="p-8">
      <div className="mb-12">
        <Title className="text-lg font-bold text-dark-blue">PRAVNA LICA</Title>
        <div className="w-96">
          <Text className="mr-2">Dokumentacija za pravna lica</Text>
          <Upload
            disabled={documentationPravnaLica}
            customRequest={uploadDocumentationPravnaLica}
            onRemove={handleRemove}
            showUploadList="false"
            multiple={false}
            maxCount={1}
            accept=".doc,.docx,.pdf"
          >
            <Button
              disabled={
                documentationPravnaLica ||
                uploadingType === documentationType.pravnaLica
              }
              icon={<SettingOutlined />}
            >
              Klikni da dodaš
            </Button>
          </Upload>
        </div>
        {uploadingType === documentationType.pravnaLica && (
          <div className="mt-4 w-[450px] text-center ">
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
            />
            <Title className="text-light-blue-login text-sm font-bold mt-3">
              <>Ovo moze potrajati!</>
            </Title>
          </div>
        )}

        {documentationPravnaLica && (
          <div className="mt-2">
            <div className="flex justify-between items-center  w-[450px]">
              <div className="flex">
                <PaperClipOutlined />
                <a
                  className="text-light-blue-login px-2 h-6 overflow-scroll"
                  href={documentationPravnaLica?.fileUrl}
                  target="_blank"
                >
                  {documentationPravnaLica.fileName.split("_")[1]}
                </a>
              </div>

              <Button
                onClick={() => handleRemove(documentationPravnaLica)}
                type="dashed"
                className="px-2"
                icon={<DeleteOutlined />}
              ></Button>
            </div>
          </div>
        )}
      </div>
      <div className="mb-12">
        <Title className="text-lg font-bold text-dark-blue">FIZIČKA LICA</Title>
        <div className="w-96">
          <Text className="mr-2">Dokumentacija za fizička lica</Text>
          <Upload
            disabled={documentationFizickaLica}
            customRequest={uploadDocumentationFizickaLica}
            onRemove={handleRemove}
            showUploadList="false"
            multiple={false}
            maxCount={1}
            accept=".doc,.docx,.pdf"
          >
            <Button
              disabled={
                documentationFizickaLica ||
                uploadingType === documentationType.fizičkaLica
              }
              icon={<SettingOutlined />}
            >
              Klikni da dodaš
            </Button>
          </Upload>
        </div>
        {uploadingType === documentationType.fizičkaLica && (
          <div className="mt-4 w-[450px] text-center ">
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 32 }} spin />}
            />
            <Title className="text-light-blue-login text-sm font-bold mt-3">
              <>Ovo moze potrajati!</>
            </Title>
          </div>
        )}
        {documentationFizickaLica && (
          <div className="mt-2">
            <div className="flex justify-between items-center  w-[450px]">
              <div className="flex">
                <PaperClipOutlined />
                <a
                  className="text-light-blue-login px-2 h-6 overflow-scroll"
                  href={documentationFizickaLica?.fileUrl}
                  target="_blank"
                >
                  {documentationFizickaLica.fileName.split("_")[1]}
                </a>
              </div>

              <Button
                onClick={() => handleRemove(documentationFizickaLica)}
                type="dashed"
                className="px-2"
                icon={<DeleteOutlined />}
              ></Button>
            </div>
          </div>
        )}
      </div>
      <div className="mb-12">
        <Title className="text-lg font-bold text-dark-blue">
          INFORMACIJE O OBRADI PODATAKA
        </Title>
        <div className="w-96">
          <Text className="mr-2">Informacije o obradi podataka</Text>
          <Upload
            disabled={documentationObradaPodataka}
            customRequest={uploadDocumentationObradaPodataka}
            onRemove={handleRemove}
            showUploadList="false"
            multiple={false}
            maxCount={1}
            accept=".doc,.docx,.pdf"
          >
            <Button
              disabled={
                documentationObradaPodataka ||
                uploadingType === documentationType.informacijeoObradiPodataka
              }
              icon={<SettingOutlined />}
            >
              Klikni da dodaš
            </Button>
          </Upload>
        </div>
        {uploadingType === documentationType.informacijeoObradiPodataka && (
          <div className="mt-4 w-[450px] text-center ">
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 32 }} spin />}
            />
            <Title className="text-light-blue-login text-sm font-bold mt-3">
              <>Ovo moze potrajati!</>
            </Title>
          </div>
        )}
        {documentationObradaPodataka && (
          <div className="mt-2">
            <div className="flex justify-between items-center  w-[450px]">
              <div className="flex">
                <PaperClipOutlined />

                <a
                  className="text-light-blue-login px-2 h-6 overflow-scroll"
                  href={documentationObradaPodataka?.fileUrl}
                  target="_blank"
                >
                  {documentationObradaPodataka.fileName.split("_")[1]}
                </a>
              </div>

              <Button
                onClick={() => handleRemove(documentationObradaPodataka)}
                type="dashed"
                className="px-2"
                icon={<DeleteOutlined />}
              ></Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RoleLaDokumentacija;
